window.jQuery = require('jquery')

require('bootstrap-sass/assets/javascripts/bootstrap/transition')
require('bootstrap-sass/assets/javascripts/bootstrap/collapse')

// Import JavaScript
require('./components')

// Import CSS
require('./main.scss')

// Import Frond End Styleguide JavaScript and CSS
if (process.env.NODE_ENV === 'development') {
  require('../config/branding.scss')
}



// WEBPACK FOOTER //
// ./src/main.js